(function() {

    'use strict';

    angular.module('app').config(urlConfig).run(initRestrictions);

    urlConfig.$inject = ['$routeProvider', '$locationProvider'];
    initRestrictions.inject = ['$rootScope'];
    function urlConfig($routeProvider, $locationProvider) {
        $routeProvider.
            when('/', {
                templateUrl: '/templates/pages/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'vm',
                params: {
                    name: 'dashboard',
                    itemText: 'Home',
                    htmlTitle: 'Home',
                    pageTitle: 'Home',
                    icon: 'fa fa-home',
                    mainMenu: true
                }
            }).
            when('/settings', {
                templateUrl: '/templates/pages/settings.html',
                controller: 'SettingsController',
                controllerAs: 'vm',
                params: {
                    name: 'settings',
                    itemText: 'Settings',
                    htmlTitle: 'Settings',
                    pageTitle: 'Settings',
                    parent: 'dashboard'
                }
            }).
            when('/reporting', {
                templateUrl: '/templates/pages/reporting.html',
                controller: 'ReportingController',
                controllerAs: 'vm',
                params: {
                    name: 'reporting',
                    itemText: 'Reporting',
                    htmlTitle: 'Reporting',
                    pageTitle: 'Reporting',
                    icon: 'fa fa-line-chart',
                    mainMenu: true,
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Difot Summary',
                            name: 'difotSummary',
                            icon: '',
                            url: '/reporting?tab=difot-summary'
                        },
                        {
                            itemText: 'Company By Spend',
                            name: 'companyBySpend',
                            icon: '',
                            url: '/reporting?tab=company-by-spend'
                        },
                        {
                            itemText: 'Carrier By Spend',
                            name: 'carrierBySpend',
                            icon: '',
                            url: '/reporting?tab=carrier-by-spend'
                        }
                    ]
                }
            }).
            when('/shipments', {
                templateUrl: '/templates/pages/shipments.html',
                controller: 'ShipmentsController',
                controllerAs: 'shipments',
                params: {
                    name: 'shipments',
                    itemText: 'Shipments',
                    htmlTitle: 'Shipments',
                    pageTitle: 'Shipments',
                    icon: 'fa fa-dropbox',
                    customHeader: true,
                    mainMenu: true,
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Shipments Search',
                            name: 'shipmentSearch',
                            icon: '',
                            url: '/shipments?tab=shipments-search'
                        },
                        {
                            itemText: 'Break Bulk Shipments',
                            name: 'breakBulkShipments',
                            icon: '',
                            url: '/shipments?tab=break-bulk-shipments'
                        },
                        {
                            itemText: 'Consolidated Shipments',
                            name: 'consolidatedShipments',
                            icon: '',
                            url: '/shipments?tab=consolidated-shipments'
                        },
                        {
                            itemText: 'Archived Shipments',
                            name: 'archivedShipments',
                            icon: '',
                            url: '/shipments?tab=archived-shipments'
                        },
                        {
                            itemText: 'Tracking',
                            name: 'tracking',
                            icon: '',
                            url: '/shipments/tracking/'
                        }
                    ]
                }
            }).
            when('/clients', {
                templateUrl: '/templates/pages/client.html',
                controller: 'ClientController',
                params: {
                    name: 'clients',
                    itemText: 'Clients',
                    htmlTitle: 'Clients',
                    pageTitle: 'Clients',
                    icon: 'fa fa-user',
                    mainMenu: true,
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Company Search',
                            icon: '',
                            name: 'companySearch',
                            url: '/clients'
                        },
                        {
                            itemText: 'Onboard New Client',
                            name: 'onboardNewClient',
                            icon: '',
                            url: '/clients/company/details' //create new company
                        }
                    ]
                }
            }).
            when('/manifests', {
                templateUrl: '/templates/pages/manifests.html',
                controller: 'ManifestsController',
                controllerAs: 'ms',
                params: {
                    itemText: 'Manifests',
                    htmlTitle: 'Manifests',
                    pageTitle: 'Manifests',
                    icon: 'fa fa-file-text',
                    mainMenu: true,
                    name: 'manifests',
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Manifest Search',
                            name: 'manifestSearch',
                            icon: '',
                            url: '/manifests?tab=manifest-search'
                        },
                        {
                            itemText: 'Non-Manifested Shipments',
                            name: 'nonManifestSearch',
                            icon: '',
                            url: '/manifests?tab=non-manifested'
                        },
                        {
                            itemText: 'Scheduled Pick Up\'s',
                            name: 'scheduledPickups',
                            icon: '',
                            url: '/manifests?tab=scheduled-pickups'
                        },
                        {
                            itemText: 'FTP Direct Booking',
                            name: 'ftpDirectBooking',
                            icon: '',
                            url: '/ftp-direct-booking'
                        },
                        {
                            itemText: 'Truck/Driver Information Audit',
                            name: 'truckInformationAurdit',
                            icon: '',
                            url: '/truck-information-audit'
                        }
                    ]
                }
            }).
            when('/carriers/carrier-profiles', {
                templateUrl: '/templates/pages/carriers.html',
                controller: 'CarriersController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Carriers',
                    htmlTitle: 'Carriers',
                    pageTitle: 'Carriers - Carrier Profiles',
                    icon: 'fa fa-truck',
                    mainMenu: true,
                    name: 'carriers',
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Carrier Profiles',
                            name: 'carrierProfiles',
                            icon: '',
                            url: '/carriers/carrier-profiles'
                        },
                        {
                            itemText: 'Service Profiles',
                            name: 'serviceProfiles',
                            icon: '',
                            url: '/carriers/service-profiles'
                        },
                        {
                            itemText: 'Fuel Levies',
                            name: 'fuelLevies',
                            icon: '',
                            url: '/carriers/fuel-levies'
                        },
                        {
                            itemText: 'System Enabled Postcodes Worldwide',
                            name: 'systemEnabledPostcodes',
                            icon: '',
                            url: '/carriers/system-postcodes'
                        },
                        {
                            itemText: 'Pop Locker Providers',
                            name: 'popLockers',
                            url: '/carriers/pop-lockers'
                        }
                    ]
                }
            }).
            when('/routing-matrix', {
                templateUrl: '/templates/pages/routing-matrix.html',
                controller: 'RoutingMatrixController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Routing Matrix',
                    htmlTitle: 'Routing Matrix',
                    pageTitle: 'Routing Matrix',
                    icon: 'fa fa-th',
                    mainMenu: true,
                    name: 'routingMatrix'
                }
            }).
            when('/bba-profile-manager', {
                templateUrl: '/templates/pages/bba-profile-manager.html',
                controller: 'BBAProfileManagerController',
                controllerAs: 'vm',
                params: {
                    itemText: 'BBA Profile Manager',
                    htmlTitle: 'BBA Profile Manager',
                    pageTitle: 'BBA Profile Manager',
                    icon: 'fa fa-briefcase',
                    mainMenu: true,
                    name: 'profileManager',
                }
            }).
            when('/margins', {
                templateUrl: '/templates/pages/services.html',
                controller: 'ServicesController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Margins',
                    htmlTitle: 'Margins',
                    pageTitle: 'Margins',
                    icon: 'fa fa-cog',
                    mainMenu: true,
                    name: 'margins',
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Connections & Margins',
                            name: 'clientServices',
                            icon: '',
                            url: '/margins'
                        },
                        {
                            itemText: 'Connections & Margins Linking',
                            name: 'serviceLinking',
                            icon: '',
                            url: '/margins/new'
                        }
                    ]
                }
            }).
            when('/areas', {
                templateUrl: '/templates/pages/routes/areas.html',
                controller: 'AreasController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Area and Route',
                    htmlTitle: 'Area & Route',
                    pageTitle: 'Area & Route',
                    icon: 'fa fa-road',
                    mainMenu: true,
                    hasSubMenu: true,
                    name: 'Area and Route',
                    subMenus: [
                        {
                            itemText: 'Areas',
                            name: 'Area and Route',
                            icon: '',
                            url: '/areas'
                        }, {
                            itemText: 'Routes',
                            name: 'Area and Route',
                            icon: '',
                            url: '/areas/routes'
                        }
                    ]
                }
            }).
            when('/jobs/map', {
                templateUrl: '/templates/pages/jobs-map-overview.html',
                controller: 'JobMapOverviewController',
                controllerAs: 'vm',
                params: {
                    customLayout: 'jobs-layout',
                    customHeader: true,
                    itemText: 'Job Mapping',
                    htmlTitle: 'Job Mapping',
                    pageTitle: 'Job Mapping',
                    icon: 'fa fa-tasks',
                    mainMenu: true,
                    hasSubMenu: true,
                    name: 'jobs',
                    subMenus: [
                        {
                            itemText: 'Job Map',
                            name: 'job-map',
                            icon: '',
                            url: '/jobs/map'
                        },
                        {
                            itemText: 'Jobs',
                            name: 'jobs',
                            icon: '',
                            url: '/jobs'
                        },
                        {
                            itemText: 'Job Assignment',
                            name: 'route-planning',
                            icon: '',
                            url: '/route-planning'
                        }
                    ]
                }
            }).
            when('/fleets', {
                templateUrl: '/templates/pages/fleets.html',
                controller: 'FleetsController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Fleet Management',
                    htmlTitle: 'Fleet Management',
                    pageTitle: 'Fleet Management',
                    icon: 'fa fa-car',
                    mainMenu: true,
                    name: 'fleets',
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Fleets',
                            name: 'fleets',
                            icon: '',
                            url: '/fleets'
                        },
                        {
                            itemText: 'Vehicle Types',
                            name: 'vehicle-types',
                            icon: '',
                            url: '/fleets/vehicle-types'
                        },
                        {
                            itemText: 'Vehicles',
                            name: 'vehicles',
                            icon: '',
                            url: '/fleets/vehicles'
                        },
                        {
                            itemText: 'Driver Groups',
                            name: 'driver-groups',
                            icon: '',
                            url: '/fleets/driver-groups'
                        },
                        {
                            itemText: 'Drivers',
                            name: 'drivers',
                            icon: '',
                            url: '/fleets/drivers'
                        }
                    ]
                }
            }).
            when('/compliance', {
                templateUrl: '/templates/pages/compliance.html',
                controller: 'ComplianceController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Compliance',
                    htmlTitle: 'Compliance',
                    pageTitle: 'Compliance',
                    icon: 'glyphicon glyphicon-list-alt',
                    mainMenu: true,
                    name: 'compliance',
                }
            }).
            when('/marketplaces', {
                templateUrl: '/templates/pages/marketplaces.html',
                controller: 'MarketplacesController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Marketplaces',
                    htmlTitle: 'Marketplaces',
                    pageTitle: 'Marketplaces',
                    icon: 'fa fa-shopping-cart',
                    name: 'marketplaces',
                    mainMenu: true,
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Marketplaces Configuration',
                            name: 'marketplacesConfiguration',
                            icon: '',
                            url: '/marketplaces?tab=configuration'
                        },
                        {
                            itemText: 'Marketplaces Reporting',
                            name: 'marketplacesReporting',
                            icon: '',
                            url: '/marketplaces?tab=reporting'
                        }
                    ]
                }
            }).
            when('/api-access', {
                templateUrl: '/templates/pages/api-access.html',
                controller: 'ApiAccessController',
                controllerAs: 'vm',
                params: {
                    itemText: 'API Access',
                    htmlTitle: 'API Access',
                    pageTitle: 'API Access',
                    icon: 'fa fa-cloud',
                    mainMenu: true,
                    hasSubMenu: true,
                    name: 'APIAccess',
                    subMenus: [
                        {
                            itemText: 'Clients',
                            name: 'clients',
                            icon: '',
                            url: '/api-access'
                        },
                        {
                            itemText: 'Third Party Accounting App',
                            name: 'thirdPartyAccountingApp',
                            icon: '',
                            url: '/api-access/third-party-accounting-app'
                        },
                    ]
                }
            }).
            when('/networking', {
                templateUrl: '/templates/pages/network-effect.html',
                controller: 'NetworkEffectController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Networking',
                    htmlTitle: 'Networking',
                    pageTitle: 'Networking',
                    icon: 'fa fa-globe',
                    mainMenu: true,
                    name: 'networking'
                }
            }).
            when('/accounting-unprocessed-shipments', {
                templateUrl: '/templates/pages/accounting/accounting-unprocessed-shipments.html',
                controller: 'AccountingUnprocessedController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Invoicing',
                    htmlTitle: 'Unprocessed Shipments',
                    pageTitle: 'Unprocessed Shipments',
                    icon: 'fa fa-file',
                    name: 'accounting-unprocessed-shipments',
                    mainMenu: true,
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Unprocessed Shipments',
                            name: 'unprocessed-shipments',
                            icon: '',
                            url: '/accounting-unprocessed-shipments'
                        },
                        {
                            itemText: 'Unprocessed Invoices',
                            name: 'unprocessed-invoices',
                            icon: '',
                            url: '/accounting-invoices'
                        },
                        {
                            itemText: 'Accounts Payable',
                            name: 'accounts-payable',
                            icon: '',
                            url: '/accounting/accounts-payable'
                        },
                        {
                            itemText: 'Surcharges',
                            name: 'surcharges',
                            icon: '',
                            url: '/accounting/surcharges'
                        }
                    ]
                }
            }).
            when('/accounting-billing', {
                templateUrl: '/templates/pages/accounting/customer-billing.html',
                controller: 'AccountingCustomerBillingController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Billing',
                    htmlTitle: 'Billing',
                    pageTitle: 'Billing',
                    icon: 'fa fa-calculator',
                    name: 'accounting-billing',
                    mainMenu: true,
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Pending Customers For Billing',
                            name: 'customer-billing',
                            icon: '',
                            url: '/accounting-billing'
                        },
                        {
                            itemText: 'Historical Billing',
                            name: 'historical-billing',
                            icon: '',
                            url: '/accounting/historical-billing/'
                        },
                        {
                            itemText: 'Issued Credit/Debit Notes',
                            name: 'issued-credit-notes',
                            icon: '',
                            url: '/accounting/issue-credit-notes'
                        },
                        {
                            itemText: 'Customers Billing Settings',
                            name: 'customers-billing-settings',
                            icon: '',
                            url: '/accounting/customers-billing-settings'
                        }
                    ]
                }
            }).
            when('/transit-warranty', {
                templateUrl: '/templates/pages/transit-warranty/transit-warranty-rates.html',
                controller: 'TransitWarrantyRatesController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Transit Warranty',
                    htmlTitle: 'Transit Warranty',
                    pageTitle: 'Transit Warranty Rates',
                    icon: 'fa fa-bar-chart',
                    name: 'transit-warranty',
                    mainMenu: true,
                    hasSubMenu: true,
                    subMenus: [
                        {
                            itemText: 'Rates',
                            name: 'transit-warranty-rates',
                            icons: '',
                            url: '/transit-warranty'
                        },
                        {
                            itemText: 'Claims',
                            name: 'transit-warranty-claims',
                            icon: '',
                            url: '/transit-warranty/claims'
                        },
                        {
                            itemText: 'Reports',
                            name: 'transit-warranty-reports',
                            icon: '',
                            url: '/transit-warranty/reports'
                        },
                        {
                            itemText: 'Providers',
                            name: 'transit-warranty-providers',
                            icon: '',
                            url: '/transit-warranty/providers'
                        },
                    ]
                }
            }).
            when('/affiliates-sales', {
                templateUrl: '/templates/pages/affiliatesSales.html',
                controller: 'AffiliatesSalesController',
                params: {
                    itemText: 'Affiliates Sales',
                    htmlTitle: 'Affiliates Sales',
                    pageTitle: 'Affiliates Sales',
                    icon: 'fa fa-users',
                    mainMenu: true,
                    name: 'affiliatesSales'
                }
            }).
            when('/service-tickets', {
                templateUrl: '/templates/pages/service-tickets.html',
                controller: 'ServiceTicketsController',
                controllerAs: 'vm',
                params : {
                    itemText: 'Service Request',
                    htmlTitle: 'Service Request',
                    pageTitle: 'Service Request',
                    icon: 'fa fa-ticket',
                    mainMenu: true,
                    name: 'serviceTickets'
                }
            }).
            when('/cross-dock', {
                templateUrl: '/templates/pages/crossDock.html',
                controller: 'CrossDockController',
                params: {
                    itemText: 'Cross Dock',
                    htmlTitle: 'Cross Dock',
                    pageTitle: 'Cross Dock',
                    icon: 'fa fa-random',
                    mainMenu: true,
                    name: 'crossDock'
                }
            }).
            when('/administration', {
                templateUrl: '/templates/pages/administration.html',
                controller: 'AdministrationController',
                params: {
                    itemText: 'Administration',
                    htmlTitle: 'Administration',
                    pageTitle: 'Administration',
                    icon: 'fa fa-sitemap',
                    name: 'administration',
                    mainMenu: true
                }
            }).
            when('/bba-billing', {
                templateUrl: '/templates/pages/BBABilling.html',
                controller: 'BBABillingController',
                params: {
                    itemText: 'BBA Mastro Billing',
                    htmlTitle: 'BBA Mastro Billing',
                    pageTitle: 'BBA Mastro Billing',
                    icon: 'fa fa-credit-card',
                    mainMenu: true,
                    name: 'BBABilling'
                }
            }).
            when('/logout/', {
                template: false,
                controller: 'ExitController',
                params: {}
            }).
            when('/terms-and-conditions', {
                templateUrl: '/templates/pages/terms-and-conditions/terms-and-conditions.html',
                controller: 'TermsAndConditionsController'
            }).
            when('/search', {
                name: 'Search',
                templateUrl: '/templates/pages/GlobalSearch.html',
                controller: 'GlobalSearchController',
                controllerAs: 'vm',
                params: {
                    itemText: 'Search',
                    htmlTitle: 'Search',
                    pageTitle: 'Search'
                }
            }).
            when('/under-maintenance', {
                templateUrl: '/templates/pages/under-maintenance.html',
                controller: 'UnderMaintenanceController',
                controllerAs: 'vm',
                params: {
                    customHeader: true,
                    itemText: 'Under Maintenance',
                    htmlTitle: 'Under Maintenance',
                    pageTitle: 'Under Maintenance',
                    mainMenu: false
                }
            }).
            otherwise({
                redirectTo: '/'
            });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }
    function initRestrictions($rootScope) {
        console.log($rootScope);
    }
})();



// WEBPACK FOOTER //
// ./js/urls/urls.js